import React from 'react';
import Image from '../../../../../../components/ZUILib/Image/Image';
import Favourite from '../../../../../../components/ZUILib/Favourite';
import commonUtil from '../../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../../utils/clientConstant';

export default class Template2 extends React.Component {

  render() {
    const { lables } = this.props;
    let pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.liverpool.label');
    if (commonUtil.getBrand() === defaultConst.constBrand.PB) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.pb.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.PBK) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.pbk.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.GAP) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.gap.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WLM) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.wlm.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WS) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.ws.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.TRU) {
      pdfBrandMessage = commonUtil.getLabel(lables.GuestviewPage, 'guestview.pdf.exclusive.product.tru.label');
    }

    const _imgsrc1 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/guest/no-image.png',
      },
    ];

    const giftListRow = (giftDetail, categoryName, index) => {
      if (categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') {
        this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
      } else {
        this.defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';
      }
      const giftSalePrice = commonUtil.getCurrency(giftDetail.salePrice);
      const imageAttr1 = {
        id: 'img1',
        alt: 'Liverpool',
        src: giftDetail.imageURL,
        altImg: giftDetail?.altImageUrl || this.defaultImage, // this.defaultImage, // TODO: Need to upload all images in static asset
        className: 'imgPdf_img',
      };
      let deliverAddressNickName = '';
      if (!commonUtil.isObjectEmpty(this.props.registeredGiftList) && this.props.registeredGiftList.deliveryAddressInfo.length > 1) {
        this.props.registeredGiftList.deliveryAddressInfo.forEach((p1) => {
          if (p1.deliveryAddressId === giftDetail.addressId) {
            deliverAddressNickName = p1.deliveryAddressName;
          }
        });
      } else if (giftDetail.deliveryMode === 'physical') {
       !commonUtil.isObjectEmpty(this.props.registeredGiftList) && this.props.registeredGiftList.deliveryAddressInfo.length > 0 && this.props.registeredGiftList.deliveryAddressInfo.forEach((p1) => {
          if (p1.deliveryAddressId === giftDetail.addressId) {
            deliverAddressNickName = p1.deliveryAddressName;
          }
        });
        if(deliverAddressNickName==''){
          deliverAddressNickName = this.props.registeredGiftList.deliveryAddressInfo[0].deliveryAddressName;
        }
      }
      return (<tr index={index}>
        <td className="text-center pl-1" style={{ width: '5%' }}>
          <Favourite id={giftDetail.skuId} disabled="true" item={giftDetail} checked={giftDetail.isFavourite} />
        </td>
        <td className="imgInner" style={{ width: '10%'}}>
          <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
        </td>
        <td className="textToLeft articleInner" style={{ width: '25%' }}>
          <div className="textToBold">{giftDetail.desc}</div>
          <div className="sku">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}: {giftDetail.skuId}</div>
        </td>
        <td className="priceAndQuant priceInner text-center" style={{ width: '10%' }}>
          <div className="textToBold">{giftSalePrice}</div>
        </td>
        <td className="priceAndQuant quantityInnerEG text-center" style={{ width: '7%' }}>
          <div className="btn-group"><span className="textToBold">{giftDetail.quantity}</span></div>
        </td>
        <td className="priceAndQuant disponibilityInner text-center" style={{ width: '10%' }}>
          {(giftDetail.availability === 'true' || giftDetail.availability) ? <div className="textGreen">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.displonsible.label')}</div> : <div className="textRed">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.nodisplonsible.label')}&nbsp;&nbsp;</div>}
        </td>
        <td className="text-center addressInner" style={{ width: '15%' }}>
          {deliverAddressNickName}
        </td>
        <td className="modeGiftInner text-center" style={{ width: '17%' }}>{giftDetail.deliveryMode === 'physical' ? commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.physical.label') : commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.electronic.label') }</td>
      </tr>);
    };
    const giftListTable = giftItems => (
      <React.Fragment>
        {(giftItems.categoryName === 'Gift Certificate' || giftItems.categoryName === 'Certificado Electrónico') ? <div className="col-xs-12">
          <p className="label_categoria">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.category.label')} : <b>Certificado Electrónico</b><span className="nota pull-right">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.giftcertificates.notes.label')}</span></p>
        </div> : <div className="col-xs-12">
          <p className="label_categoria">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.category.label')} : <b>{giftItems.categoryName}</b></p>
        </div> }
        <div className="col-xs-12 contentTable">
          <table className="tableResults">
            <thead className="rowLines">
              <tr>
                <td style={{ width: '5%' }}>&nbsp;</td>
                <td className="text-center" style={{ width: '10%' }} />
                <td className="text-left" style={{ width: '24%' }}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.desc.label')}</td>
                <td className="text-center" style={{ width: '10%' }} >
                  <a>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.price.label')}
                  </a>
                </td>
                <td className="text-center"  style={{ width: '7%' }} >{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}</td>
                <td className="text-center" style={{ width: '10%' }}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.itemavailable.label')}</td>
                <td className="text-center" style={{ width: '15%' }}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.address.label')}</td>
                <td className="text-center" style={{ width: '17%' }}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}</td>
              </tr>
            </thead>
            <tbody>
              {giftItems.itemInfo ? giftItems.itemInfo.map(giftItem => giftListRow(giftItem, giftItems.categoryName)) : ''}
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );


    return (
      <React.Fragment>
        <div className="row info">
          <div className="col-xs-8">
            <h3>
              <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.mydata.message')}</p>
            </h3>
            <p><b>{pdfBrandMessage}</b></p>
          </div>
          <div className="col-xs-4 text-right event">
            <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.date.of.event.label')}: {commonUtil.formattingDate(this.props.eventDate)}</p>
            <p>Tipo de evento: {this.props.eventType}</p>
            <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.event.number.label')}: {this.props.eventId}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <p className="resultsTitle">Regalos registrados /<strong> {this.props.giftCount}</strong></p>
          </div>
        </div>
        {this.props.categoryInfo ? this.props.categoryInfo.map(giftListTable) : ''}

      </React.Fragment>
    );
  }
}